/**
 * Реестр "держателей задачи" панелей. Мутации store (task/mutations.js, utils/task.js) обновляют state.page.task;
 * панель с собственными данными (panel-context) держит свою копию задачи ({item, children, ...}) и регистрирует её
 * здесь, чтобы комментарии, черновики и обновления полей доходили и до неё.
 */
const getters = new Set();

/**
 * Регистрирует держателя задачи панели.
 * @param getter функция, возвращающая актуальный объект {item, children, ...} (он может быть заменён целиком)
 * @returns {function} отмена регистрации
 */
export const registerTaskHolder = (getter) => {
	getters.add(getter);
	return () => getters.delete(getter);
};

/**
 * Держатели задач панелей, кроме state.page.task (его мутации обрабатывают сами).
 * @param state
 * @returns {Array}
 */
export const extraTaskHolders = (state) => {
	const holders = [];
	getters.forEach(getter => {
		const holder = getter();
		if (holder && holder !== state?.page?.task && holder.item && !holders.includes(holder)) holders.push(holder);
	});
	return holders;
};
